export enum SortDirection {
  Ascending = 'asc',
  Descending = 'desc'
}
